import React from 'react';

interface ArrowBackProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
}

/**
 * Arrow back icon SVG component
 */
const ArrowBack: React.FC<ArrowBackProps> = ({
  fill = '#5E5E5E',
  style = {},
  ...props
}) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={style}
    {...props}
  >
    <path
      d='M13.3333 7.33334H5.21996L8.94663 3.60667L7.99996 2.66667L2.66663 8L7.99996 13.3333L8.93996 12.3933L5.21996 8.66667H13.3333V7.33334Z'
      fill={fill}
    />
  </svg>
);

export default ArrowBack;
